module.exports = __webpack_public_path__ + "636fe3fb2e7f485679468c348011a95f.pdf";